import { valueToLabel } from "@/modules/dimension_values/components/BucketUnits";
import BucketValuePutDTO = App.Data.BucketValuePutDTO;
import BucketCreationDTO = App.Data.BucketCreationDTO;
import DimensionDO = App.Data.DimensionDO;
import { bucketCreationValues } from "./BucketCreation.vue";

export const randomizeColor = (colors: string[]): string => {
	if (!colors.length) return "#cccccc";
	return colors[Math.floor(Math.random() * colors.length)];
};

export const randomizeColors = (values: BucketValuePutDTO[], colors: string[], startColorIndex?: number): void => {
	if (!colors.length) return;
	let colorIndex = startColorIndex ?? Math.floor(Math.random() * colors.length);
	values.forEach((value) => {
		value.hex_color_value = colors[colorIndex];
		colorIndex = (colorIndex + 1) % colors.length;
	});
};

function mergeLabels(
	label: string,
	nextLabel: string,
	options: { isFirst: boolean; isLast: boolean; gapSizeIsOne: boolean }
): string {
	if (options.isFirst) return `< ${nextLabel}`;
	if (options.isLast) return `> ${label}`;
	if (options.gapSizeIsOne) return label; // no need for "x - y"
	return `${label} - ${nextLabel}`;
}

export function generateLabel(
	value: number,
	nextValue: number | null,
	isFirst: boolean,
	dimension: DimensionDO,
	t: (key: string) => string
): string {
	const label = valueToLabel(value, dimension.unit, t);
	const nextLabel = valueToLabel(nextValue, dimension.unit, t);
	const isLast = nextValue === null;
	const gapSizeIsOne =
		nextValue !== null && Math.floor(nextValue) - Math.floor(value) <= 1;
	return mergeLabels(label, nextLabel, { isFirst, isLast, gapSizeIsOne });
}

export function createBucketFromArray(
	startValues: number[],
	dimension: DimensionDO,
	t: (key: string) => string,
	bucketAlreadyExists: boolean = false
): BucketValuePutDTO[] {
	const values: BucketValuePutDTO[] = [];
	let nextLabel: string | null = null;

	for (const [i, value] of startValues.entries()) {
		const nextValue = startValues[i + 1];
		const label = nextLabel ?? valueToLabel(value, dimension.unit, t);
		nextLabel = valueToLabel(nextValue, dimension.unit, t);

		const isFirst = i === 0 && !bucketAlreadyExists;
		const isLast = i === startValues.length - 1;
		const gapSizeIsOne = nextValue - value === 1;

		values.push({
			dimension_value_id: null,
			sort_order: i,
			start_value: value,
			label: mergeLabels(label, nextLabel, { isFirst, isLast, gapSizeIsOne }),
			hex_color_value: "",
		});
	}
	return values;
}

export function createBucketFromConfig(
	bucket: bucketCreationValues,
	dimension: DimensionDO,
	t: (key: string) => string,
	bucketAlreadyExists: boolean = false
): BucketValuePutDTO[] {
	const values: number[] = [];

	for (let i = 0; i < bucket.item_count; i++) {
		values.push(bucket.start_value + i * bucket.gap_size);
	}

	return createBucketFromArray(values, dimension, t, bucketAlreadyExists);
}
